<template>
  <div class="ws-group">
    <b-field class="ws-field exam-group"
      :label="$t('Выберите учебную группу')"
      :type="{'is-danger': errors.has('group'+(group.id || group.guid))}"
      :message="errors.first('group'+(group.id || group.guid))"
    >
      <ws-refbook-field
        entity="refbook/study_groups"
        :name="'group'+(group.id || group.guid)"
        field="name"
        v-model="educationGroup.name"
        :guid.sync="educationGroup.guid"
        :item.sync="educationGroup.item"
        :isFocus="true"
        key="group-input"
        v-validate="{
          required: true,
          selected: educationGroup.guid,
          checkGroupCode: isGroupValidate && [groupProgramCode, competenceCode]
        }"
        :query="{
          education_guid: filters.education_guid,
          education_year: filters.education_year,
          region_guid: filters.region_guid
        }"
      >
        <template slot-scope="props" slot="item">
          <div :title="getTitle(props.option)">
            <strong v-text="props.option.name"></strong>
            <span class="ml-1 has-text-danger">{{ props.option.education_year }}/{{props.option.education_year+1}}</span><br>
            <span class="group-region is-size-5">{{ getGroupRegion(props.option) }}</span>
            <span v-text="props.option.profession"></span><br>
            <span v-text="props.option.university.title.display"></span>
          </div>
        </template>
      </ws-refbook-field>
    </b-field>
    <b-button class="ws-field__filters is-text" @click="active = true">
      <ws-icon
        class="ws-button__icon"
        name="filter"
        :fill="true"
        width="14"
        height="14"
        :color="`${isFilters ? '#6D9AE8' : '#000000'}`"
      />
    </b-button>
    <div v-if="active" class="filters-overlay" @click.self="closeFilters">
      <div class="filters-group">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="filters-group__header">
              <h3 class="has-text-weight-bold is-size-2">Фильтры</h3>
              <button
                v-if="institution.guid || region.guid || selectedYear"
                type="button"
                class="ws-field__clear ws-button button is-text is-small"
                @click="resetFilters"
              >
                Сбросить фильтры
              </button>
            </div>
          </div>
          <div class="column is-12">
            <ws-permission-node
              :resources="['resources/region']"
              :type="{'is-danger': errors.has('region')}"
              :message="errors.first('region')"
              >
              <b-field
                class="ws-field"
                :label="$t('Регион')"
              >
                <ws-refbook-field
                  :name="'region'"
                  entity="public/refbook/region"
                  field="title.display"
                  :item.sync="region.item"
                  :guid.sync="region.guid"
                  v-model="region.value"
                  key="region-input"
                  :data-vv-as="$t('Регион')"
                  :isFocus="true"
                  :params="{country: config.default_country_code}"
                >
                  <template
                    slot="empty"
                    v-text="$t('Ничего не найдено')"
                  ></template>
                </ws-refbook-field>
              </b-field>
            </ws-permission-node>
          </div>
          <div class="column is-12">
            <b-field
              class="ws-field"
              :label="$t('Образовательная Организация')"
            >
              <ws-refbook-field
                entity="public/refbook/education/institution"
                field="title.display"
                :name="'institution'"
                :guid.sync="institution.guid"
                :item.sync="institution.item"
                v-model="institution.value"
                key="institution-input"
                :data-vv-as="$t('ОО')"
                :query="{ region_guid: region.guid }"
                :isFocus="true"
              >
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                <template
                    slot="item"
                    slot-scope="props"
                >
                  <p>
                    <ws-icon v-if="props.option.visible === false" name="stop" color="red" class="icon-stop" width="15" height="15"/>
                    {{ props.option.title.display }}
                  </p>
                </template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-12">
            <div class="ws-field">
              <button
                v-if="selectedYear"
                type="button"
                class="ws-field__clear ws-button button is-text"
                @click="clearYear()"
              >
                <ws-icon
                  class="ws-button__icon"
                  name="close-thin"
                  color="#000000"
                  :fill="false"
                  width="17"
                  height="11"
                />
              </button>
              <b-field class="years-field"
                :label="$t('Год')">
                <b-autocomplete
                  class="ws-field__control"
                  v-model="selectedYear"
                  :value="selectedYear"
                  :data="yearsList"
                  :open-on-focus="true"
                  :clearable="true"
                >
              </b-autocomplete>
              </b-field>
            </div>
          </div>
        </div>
        <div class="columns group-filters__footer">
          <div class="column is-6">
            <button class="ws-button button is-large is-fullwidth" type="button" @click="closeFilters">
              <span class="is-size-4 has-text-weight-bold" v-text="$t('Закрыть')"></span>
            </button>
          </div>
          <div class="column is-6">
            <button class="ws-button button is-large is-primary is-fullwidth" type="button" @click="setFilters">
              <span class="is-size-4 has-text-weight-bold" v-text="$t('Применить')"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { get } from 'lodash'
// import { APPLICATION_TYPES, LEVEL_TYPES } from '@/services/constants.service'

const getYearsList = () => {
  const currentYear = moment().year()
  const list = []
  const START_YEAR = currentYear - 6
  for (let year = START_YEAR; year < currentYear + 2; year++) {
    list.push({ value: year, label: year })
  }
  return list
}

export default {
  name: 'ws-request-group-field',
  props: {
    group: {
      type: Object,
      default: () => {}
    },
    setEducationGroup: {
      type: Function
    },
    exam: Object
  },
  inject: {
    $validator: '$validator'
  },
  data () {
    return {
      config: __config,
      active: false,
      educationGroup: this.group.education_group,
      filters: {
        education_guid: undefined,
        education_year: undefined,
        region_guid: undefined
      },
      isFilters: false,
      institution: {
        guid: undefined,
        item: null,
        region: undefined,
        value: ''
      },
      region: {
        guid: undefined,
        item: null,
        value: ''
      },
      selectedYear: null,
      yearsList: undefined
    }
  },
  computed: {
    isGroupValidate () {
      // const { codeType, application_type: appType } = this.exam
      // const types = codeType && appType[0] ? [codeType, appType[0]] : this.exam.flags

      return (
        // types.includes(LEVEL_TYPES.BASIC) &&
        // types.includes(APPLICATION_TYPES.FINAL) &&
        this.competenceCode &&
        this.groupProgramCode
      )
    },
    competenceCode () {
      return get(this.exam, 'competence.item.code', '') || get(this.exam, 'accred_comps.competency.code', '')
    },
    groupProgramCode () {
      return get(this.educationGroup, 'item.edu_program.code', '')
    }
  },
  created () {
    const list = getYearsList()
    this.yearsList = list
  },
  watch: {
    educationGroup: {
      immediate: true,
      handler (value) {
        this.setEducationGroup(value)
      }
    },
    region: {
      immediate: true,
      handler (value) {
        const { guid = undefined } = value
        const institutionRegGuid = this.institution.region

        if (institutionRegGuid !== guid) {
          this.institution = {
            guid: undefined,
            item: null,
            region: undefined,
            value: ''
          }
        }
      }
    }
  },
  methods: {
    setFilters () {
      const eduGuid = this.institution.guid
      const regionGuid = this.region.guid
      const eduYear = this.selectedYear || undefined

      const isFilters = Boolean(eduGuid || eduYear || regionGuid)

      this.filters = {
        education_guid: eduGuid,
        education_year: eduYear,
        region_guid: regionGuid
      }
      this.isFilters = isFilters
      if (isFilters) {
        this.educationGroup = {
          guid: null
        }
      }

      this.closeFilters()
    },
    closeFilters () {
      this.active = false
    },
    getGroupRegion (option) {
      return get(option, 'university.address.region.title.display', '')
    },
    getTitle (option) {
      const name = get(option, 'name', '')
      const year = get(option, 'education_year', '')
      const profession = get(option, 'profession', '')
      const university = get(option, 'university.title.display', '')

      return `${name} ${year}/${year + 1}\n${this.getGroupRegion(option)}\n${profession}\n${university}`
    },
    clearYear () {
      this.selectedYear = null
    },
    resetFilters () {
      this.institution.guid = undefined
      this.institution.region = undefined
      this.institution.value = ''

      this.region.guid = undefined
      this.region.value = ''

      this.selectedYear = null
    }
  }
}
</script>

<style lang="scss" scoped>
.ml-1 {
  margin-left: 5px;
}
.ws-group {
  position: relative;
}
.ws-field__filters {
  width: 14px;
  height: 14px !important;
  position: absolute;
  padding: 0;
  top: 34px;
  right: 10px;
  z-index: 1;
}

.filters {
  &-group {
    padding: 20px;
    max-width: 400px;
    min-width: 400px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    box-shadow: 0 4px 50px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    &__header {
      position: relative;
    }
    &__footer {
      margin-top: 15px;
    }
  }
  &-overlay {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(10, 10, 10, 0.86);
  }
}

/deep/ .ws-field__control {
  & .select, & select {
    width: 100%;
  }
}

.ws-field__clear {
  width: auto;
  color: hsl(218, 73%, 67%);
  z-index: 1;
}

.years-field {
  width: 100%;
  z-index: 1;
}

@media screen and (max-width: 410px) {
  .filters {
    &-group {
      max-width: none;
      min-width: auto;
      width: 100%;
    }
  }
}
</style>
